// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._18zrv77o{padding-inline:var(--ds-space-025,2px)}\n._1bah1h6o{justify-content:center}\n._1bsb1osq{width:100%}\n._1e0c1txw{display:flex}\n._1nmz1hna{word-break:break-word}\n._1ul9gktf{min-width:20px}\n._4t3igktf{height:20px}\n._k48p1wq8{font-weight:var(--ds-font-weight-medium,500)}\n._o5721jtm{white-space:pre-wrap}\n._y3gn1e5h{text-align:left}", ""]);
// Exports
module.exports = exports;
